import {FC, useEffect, useState} from 'react'
import { useSearchableMembersContext } from '../../../context/SearchableMembersContext'

interface Category {
  id: string
  name: string
}

interface MembersCategoriesListProps {
  data: Category[]
}

const MembersCategoriesList: FC<MembersCategoriesListProps> = ({data}) => {
  const [selectedId, setSelectedId] = useState<string | null>(null)
  const {setSearchParams} = useSearchableMembersContext()


useEffect(() => {
  setSearchParams((prev) => ({
    ...prev,
    category: selectedId ?? ''
  }))
}, [selectedId, setSearchParams]);


  return (
    <div className='members-page__categories'>
      {data.map((category) => (
        <div
          key={category.id}
          className={`members-page__category-item ${
            selectedId === category.id ? 'members-page__category-item--selected' : ''
          }`}
          onClick={() =>
            // PR-I-79: click en la categoría ya seleccionada la deselecciona,
            // devolviendo el listado sin filtro. Antes quedaba atrapado hasta cambiar de página.
            setSelectedId((prev) => (prev === category.id ? null : category.id))
          }
        >
          {selectedId === category.id ? (
            <svg
              width='13'
              height='14'
              viewBox='0 0 13 14'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M6.74072 10.4365C6.82321 10.9457 7.08715 12.0654 7.48291 12.4727C7.40113 12.7251 7.09158 13.3777 6.50732 13.9844V14C6.50477 13.9974 6.50206 13.9948 6.49951 13.9922C6.49728 13.9945 6.49588 13.9977 6.49365 14V13.9844C5.90933 13.3777 5.59987 12.7251 5.51807 12.4727C5.91375 12.0653 6.17778 10.9456 6.26025 10.4365H6.74072ZM4.03369 9.92773C3.86882 10.2672 3.68739 10.9966 4.28076 11.2002C4.87427 11.4037 5.18746 10.776 5.27002 10.4365H5.76514C5.68263 11.285 5.22099 12.8285 4.03369 12.2178C2.84652 11.6069 3.53895 10.4369 4.03369 9.92773ZM8.96729 9.92773C9.46198 10.437 10.154 11.607 8.96729 12.2178C7.77994 12.8286 7.31835 11.2851 7.23584 10.4365H7.72998C7.81248 10.7759 8.12656 11.4038 8.72021 11.2002C9.31318 10.9965 9.13211 10.2672 8.96729 9.92773ZM7.96338 9.0625C8.24442 9.06264 8.47216 9.29022 8.47217 9.57129C8.47217 9.85237 8.24442 10.0799 7.96338 10.0801H5.02295C4.74189 10.08 4.51416 9.85238 4.51416 9.57129C4.51417 9.29021 4.7419 9.06262 5.02295 9.0625H7.96338ZM0.074707 7.12793C0.671689 4.83672 5.27006 5.34619 6.01221 8.65527H5.02197C4.69212 8.23103 3.73571 7.38286 2.54834 7.38281C1.06416 7.38291 1.31182 9.4371 3.04346 8.90918C1.97164 9.41825 -0.455505 9.16358 0.074707 7.12793ZM6.98779 8.65527C7.72995 5.3462 12.3283 4.8367 12.9253 7.12793C13.4557 9.16368 11.0294 9.41822 9.95752 8.90918C11.689 9.43697 11.9364 7.38319 10.4526 7.38281C9.26524 7.38281 8.3079 8.23102 7.97803 8.65527H6.98779ZM6.50732 0.0234375C7.00727 0.884844 8.02883 2.86161 8.2251 4.07227C8.47245 5.59938 7.7306 5.8547 7.23584 6.61816C6.85771 7.20178 6.60149 8.14203 6.50732 8.59473V8.6543C6.50541 8.64446 6.5026 8.63446 6.50049 8.62402C6.49838 8.63446 6.49557 8.64446 6.49365 8.6543V8.59473C6.3995 8.14207 6.14327 7.20181 5.76514 6.61816C5.27037 5.85458 4.5285 5.59949 4.77588 4.07227C4.97218 2.86154 5.99375 0.884761 6.49365 0.0234375V0C6.49591 0.00387014 6.49821 0.00780077 6.50049 0.0117188C6.50277 0.00780074 6.50507 0.00387021 6.50732 0V0.0234375Z'
                fill='#460107'
              />
            </svg>
          ) : (
            <svg
              width='13'
              height='14'
              viewBox='0 0 13 14'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M6.74072 10.4365C6.82321 10.9457 7.08715 12.0654 7.48291 12.4727C7.40113 12.7251 7.09158 13.3777 6.50732 13.9844V14C6.50477 13.9974 6.50206 13.9948 6.49951 13.9922C6.49728 13.9945 6.49588 13.9977 6.49365 14V13.9844C5.90933 13.3777 5.59987 12.7251 5.51807 12.4727C5.91375 12.0653 6.17778 10.9456 6.26025 10.4365H6.74072ZM4.03369 9.92773C3.86882 10.2672 3.68739 10.9966 4.28076 11.2002C4.87427 11.4037 5.18746 10.776 5.27002 10.4365H5.76514C5.68263 11.285 5.22099 12.8285 4.03369 12.2178C2.84652 11.6069 3.53895 10.4369 4.03369 9.92773ZM8.96729 9.92773C9.46198 10.437 10.154 11.607 8.96729 12.2178C7.77994 12.8286 7.31835 11.2851 7.23584 10.4365H7.72998C7.81248 10.7759 8.12656 11.4038 8.72021 11.2002C9.31318 10.9965 9.13211 10.2672 8.96729 9.92773ZM7.96338 9.0625C8.24442 9.06264 8.47216 9.29022 8.47217 9.57129C8.47217 9.85237 8.24442 10.0799 7.96338 10.0801H5.02295C4.74189 10.08 4.51416 9.85238 4.51416 9.57129C4.51417 9.29021 4.7419 9.06262 5.02295 9.0625H7.96338ZM0.074707 7.12793C0.671689 4.83672 5.27006 5.34619 6.01221 8.65527H5.02197C4.69212 8.23103 3.73571 7.38286 2.54834 7.38281C1.06416 7.38291 1.31182 9.4371 3.04346 8.90918C1.97164 9.41825 -0.455505 9.16358 0.074707 7.12793ZM6.98779 8.65527C7.72995 5.3462 12.3283 4.8367 12.9253 7.12793C13.4557 9.16368 11.0294 9.41822 9.95752 8.90918C11.689 9.43697 11.9364 7.38319 10.4526 7.38281C9.26524 7.38281 8.3079 8.23102 7.97803 8.65527H6.98779ZM6.50732 0.0234375C7.00727 0.884844 8.02883 2.86161 8.2251 4.07227C8.47245 5.59938 7.7306 5.8547 7.23584 6.61816C6.85771 7.20178 6.60149 8.14203 6.50732 8.59473V8.6543C6.50541 8.64446 6.5026 8.63446 6.50049 8.62402C6.49838 8.63446 6.49557 8.64446 6.49365 8.6543V8.59473C6.3995 8.14207 6.14327 7.20181 5.76514 6.61816C5.27037 5.85458 4.5285 5.59949 4.77588 4.07227C4.97218 2.86154 5.99375 0.884761 6.49365 0.0234375V0C6.49591 0.00387014 6.49821 0.00780077 6.50049 0.0117188C6.50277 0.00780074 6.50507 0.00387021 6.50732 0V0.0234375Z'
                fill='#B4B4B4'
              />
            </svg>
          )}

          <div className='members-page__category-text'>{category.name}</div>
        </div>
      ))}
    </div>
  )
}

export {MembersCategoriesList}
